import React from "react";
import { ARCHITECTURE_PILLARS } from "../data/ecosystemData";

export const ArchitectureSection: React.FC = () => {
  return (
    <section className="homepage1-arch-section" id="architecture">
      <div className="homepage1-arch-intro">
        <h2 className="homepage1-section-heading">
          How indexx.ai Powers the Entire Matrix
        </h2>
        <p className="homepage1-section-subhead">
          Rather than isolated dApps, our products operate as a continuous sovereign
          layer sharing identity, capital, and machine cognition.
        </p>
      </div>

      <div className="homepage1-arch-grid">
        {ARCHITECTURE_PILLARS.map((pillar) => (
          <div key={pillar.id} className="homepage1-arch-col">
            <div>
              <div className="homepage1-arch-icon-circle">
                <span className="material-symbols-outlined text-lg">
                  {pillar.icon}
                </span>
              </div>
              <h3 className="homepage1-arch-col-title">{pillar.title}</h3>
              <p className="homepage1-arch-col-desc">{pillar.desc}</p>
            </div>

            <div className="homepage1-arch-badge">
              <span className="material-symbols-outlined text-sm">check</span>
              <span>{pillar.checkLabel}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ArchitectureSection;
